import React from 'react';

export type CheckoutContainerProps = {
  children: React.ReactNode;
  cart: React.ReactNode;
};

const CheckoutPageContainer = React.forwardRef<
  HTMLDivElement,
  CheckoutContainerProps
>(({ cart, children }: CheckoutContainerProps, ref) => {
  return (
    <div className="w-full md:bg-gray-50">
      <div
        className="flex flex-col md:flex-row md:justify-between md:content-between"
        style={{ minHeight: '100vh' }}
      >
        <div
          ref={ref}
          className="checkout-panel-main w-screen md:w-7/12 md:justify-self-center xl:justify-self-center px-2 md:px-1 lg:px-10 xl:px-20"
        >
          {children}
        </div>
        <div className="hidden summary-panel-order md:block md:px-1 md:max-h-screen lg:px-10 xl:px-20 md:w-5/12 md:justify-self-end xl:justify-self-end">
          {cart}
        </div>
      </div>
    </div>
  );
});

CheckoutPageContainer.displayName = 'CheckoutPageContainer';

export default CheckoutPageContainer;
